/**
 * Admin Provisioning Service — onboarding integral de IPS.
 */

import { post } from '@/lib/api'
import { API_ROUTES } from '@/config/constants'

export interface ProvisionInstitutionInput {
  // Institucion
  name: string
  slug: string
  nit?: string
  address?: string
  city?: string
  phone?: string
  email?: string
  // Admin
  adminEmail: string
  adminFirstName?: string
  adminLastName?: string
  // Plan
  planCode: string
  trialDaysOverride?: number
  subscriptionNotes?: string
  // Catalogo
  studyTypeCodes?: string[]
  priorityCodes?: string[]
}

export interface ProvisionInstitutionOutput {
  institution: {
    id: string
    name: string
    slug: string
    nit: string | null
  }
  adminUser: {
    id: string
    email: string
    temporaryPassword: string
  }
  subscription: {
    id: string
    planCode: string
    status: string
    trialEndsAt: string | null
    expiresAt: string | null
  }
  provisioning: {
    studyTypesCopied: number
    prioritiesCopied: number
  }
}

export const provisionInstitution = (
  data: ProvisionInstitutionInput
): Promise<ProvisionInstitutionOutput> =>
  post(API_ROUTES.ADMIN_PROVISIONING.PROVISION, data)


/**
 * Entorno de demostracion: una IPS completa con datos ficticios.
 *
 * Existe para que entregarle un entorno de evaluacion a una entidad sea una
 * operacion del panel y no una sesion de comandos en el servidor.
 */
export interface CuentaDemo {
  role: string
  email: string
  password: string
}

export interface ProvisionDemoOutput {
  institution: { id: string; name: string; slug: string }
  cuentas: CuentaDemo[]
  resumen: { pacientes: number; estudios: number; informes: number; citas: number }
  message: string
  advertencia: string
}

export const provisionDemo = (
  input: { name?: string; studyTypeCodes?: string[] } = {}
) => post<ProvisionDemoOutput>(API_ROUTES.ADMIN_PROVISIONING.PROVISION_DEMO, input)
